import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b5c689e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "submit-btn" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onActivated, onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import SimpImageUpload from '@/components/SimpImageUpload.vue'
import dayjs from 'dayjs'
import { saveVisitRecord } from '@/apis/visitRecord'
import { Toast } from 'vant'
import { getCity } from '@/apis/common'
import { uploadFileItem } from '@/apis/base'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const maxDate = ref(new Date(dayjs().format('YYYY-MM-DD HH:mm:ss')))

const state = reactive({
  formData: {
    project_id: null,
    project_name: '',
    date: null,
    person: null,
    province_id: null,
    city_id: null,
    area_id: null,
    district: null,
    pics: null,
    content: null,
    address: null
  },
  showTypePicker: false,
  showTimePicker: false,
  pid: 0,
  city_list: [],
  provinceName: null,
  cascaderValue: null
})

const formatDate = date => {
  return `${dayjs(date).format('YYYY-MM-DD HH:mm')}`
}

const fileList = ref<Array<uploadFileItem>>([])
watch(fileList, (newVal, oldVal) => {
  state.formData.pics = newVal
})

const selectedDate = ref(new Date(dayjs().format('YYYY-MM-DD HH:mm')))
// console.log(dayjs().format('YYYY/MM/DD HH:mm:ss'))

const onClickTime = () => {
  state.showTimePicker = true
}

const onTimeConfirm = val => {
  console.log(formatDate(val))
  state.showTimePicker = false
  state.formData.date = formatDate(val)
}

// 省市区查询功能
const get_region = async () => {
  let data = { Pid: state.pid }
  const res = await getCity(data)
  if (res.code == 200) {
    if (res.data) {
      res.data.forEach(e => {
        state.city_list.push({ text: e.name, value: e.id, children: [] })
      })
      console.log(state.city_list)
    }
  }
}

const onClickTab = data => {
  console.log('tab', data)
}

const onCityConfirm = ({ selectedOptions }) => {
  state.provinceName = selectedOptions.map(option => option.text).join('')
  state.formData.district = state.provinceName
  console.log('district', state.provinceName)

  // if (selectedOptions.length >= 0) state.formData.province_id = selectedOptions[0].value
  // if (selectedOptions.length >= 1) state.formData.city_id = selectedOptions[1].value
  // if (selectedOptions.length >= 2) {
  //   state.formData.area_id = selectedOptions[2].value
  //   state.formData.district = selectedOptions[2].value
  // }

  state.showTypePicker = false
}
const onCityChange = async (data: { value: number }) => {
  state.pid = data.value
  const res = await getCity({ Pid: state.pid })
  if (res.code == 200) {
    if (res.data) {
      state.city_list.forEach(i => {
        // console.log('二级联动', data.value)
        for (let l = 0; l < i.children.length; l++) {
          if (data.value === i.children[l].value) {
            let children = []
            for (let e = 0; e < res.data.length; e++) {
              children.push({ text: res.data[e].name, value: res.data[e].id, children: null })
            }
            i.children[l].children = children
          }
        }
        if (data.value == i.value) {
          for (let e = 0; e < res.data.length; e++) {
            i.children.push({ text: res.data[e].name, value: res.data[e].id, children: [] })
          }
        }
      })
    }
  }
}

const onSubmit = async () => {
  console.log('onSubmit', state.formData)

  const res = await saveVisitRecord({ ...state.formData })
  if (res.code == 200) {
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    Toast(res.msg)
  }
}

const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})
onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  state.formData.project_id = router.currentRoute.value.query.project_id.toString()
  state.formData.project_name = router.currentRoute.value.query.project_name.toString()
  get_region()
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_cascader = _resolveComponent("van-cascader")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, {
      class: "form",
      onSubmit: onSubmit,
      "input-align": "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "项目名称",
              value: _unref(state).formData.project_name
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, { title: "拜访情况" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  modelValue: _unref(state).formData.date,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).formData.date) = $event)),
                  readonly: "",
                  required: "",
                  "is-link": "",
                  name: "date",
                  label: "拜访时间",
                  placeholder: "请选择",
                  onClick: onClickTime
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_popup, {
                  show: _unref(state).showTimePicker,
                  "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).showTimePicker) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_datetime_picker, {
                      type: "datetime",
                      title: "选择日期",
                      modelValue: selectedDate.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDate).value = $event)),
                      onConfirm: onTimeConfirm,
                      onCancel: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).showTimePicker = false))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_field, {
                  modelValue: _unref(state).formData.person,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).formData.person) = $event)),
                  required: "",
                  name: "person",
                  label: "拜访人员",
                  placeholder: "请输入"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: _unref(state).provinceName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).provinceName) = $event)),
                  required: "",
                  "is-link": "",
                  readonly: "",
                  label: "所在地区",
                  placeholder: "请选择所在地区",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(state).showTypePicker = true))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_popup, {
                  show: _unref(state).showTypePicker,
                  "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_unref(state).showTypePicker) = $event)),
                  round: "",
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_cascader, {
                      modelValue: _unref(state).cascaderValue,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).cascaderValue) = $event)),
                      title: "请选择所在地区",
                      options: _unref(state).city_list,
                      "active-color": "#1989fa",
                      onClose: _cache[8] || (_cache[8] = ($event: any) => (_unref(state).showTypePicker = false)),
                      onChange: onCityChange,
                      onFinish: onCityConfirm,
                      swipeable: "",
                      onClickTab: onClickTab
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_field, {
                  modelValue: _unref(state).formData.address,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(state).formData.address) = $event)),
                  required: "",
                  name: "address",
                  label: "详细地址",
                  placeholder: "请输入"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  "input-align": "left",
                  class: "content",
                  modelValue: _unref(state).formData.content,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(state).formData.content) = $event)),
                  required: "",
                  name: "content",
                  label: "谈话内容",
                  type: "textarea",
                  rows: "5",
                  placeholder: "请输入"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  "input-align": "left",
                  class: "content",
                  required: "",
                  name: "pics",
                  label: "图片",
                  type: "textarea",
                  rows: "5",
                  placeholder: "请输入"
                }, {
                  input: _withCtx(() => [
                    _createVNode(SimpImageUpload, {
                      isShowTitle: false,
                      modelValue: fileList.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((fileList).value = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_bottom_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})